import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AfRoutes } from '../../routes';
import { AppsService } from '../apps/apps.service';

export function aclsGuard(): CanMatchFn {
  return (): Observable<boolean | UrlTree> => {
    const appsService = inject(AppsService);
    const router = inject(Router);

    return appsService.hasAclsAccess().pipe(
      map((hasAclsApp) => hasAclsApp || router.createUrlTree([AfRoutes.welcomePage]))
    );
  };
}
